<template>

<div id="s04section05" class="section-block">

  <div class="number">
    <Number text="05"/>
  </div>

  <div class="slide04-text-block">

    <div class="two-thirds-block two-thirds-block-1">

      <Common :text="$t('home.slide04.section05.text')"/>

      <div class="ul-div">

        <Ul
          section="s04section05"
          :items="[
            $t('home.slide04.section05.bullets.bullet01'),
            $t('home.slide04.section05.bullets.bullet02'),
            $t('home.slide04.section05.bullets.bullet03'),
            $t('home.slide04.section05.bullets.bullet04')
          ]"/>

      </div>

    </div>

    <div class="one-third-block one-third-block-2">
      <Qimage name="work05.png"/>
    </div>

  </div>

</div>

</template>

<script>
import Number from '../../general/texts/Number.vue'
import Common from '../../general/texts/Common.vue'
import Ul from '../../general/elements/Ul.vue'
import Qimage from '../../general/elements/Qimage.vue'

export default {
  name: 'S04Section05',
  components: {
    Number,
    Common,
    Ul,
    Qimage
  }
}
</script>

<style lang="scss" scoped>
.ul-div {
  font-size: 24px;
}

@media (max-width: 900px), (max-device-width: 900px) {
  .one-third-block-2 {
    margin: 30px 0 0 0 !important;
    position: relative;
    bottom: 0;
    left: 0;
  }
}

@media (max-width: 350px), (max-device-width: 350px) {
  .one-third-block-2 {
    position: absolute;
    bottom: 0;
  }
}
</style>
